export default __webpack_public_path__ + "static/media/view-grid.160fb6dc.svg";